import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { RouterPathService } from "../../../../core/common/variables/router-path.service";
import { ProjectGetRoofPlan } from '../../../common/api/ProjectGet';
import { SC_Input } from '../../../common/input/SC_Input';
import { GlobalService } from "../../../common/services/global.service";
import { Global } from '../../../common/utilities/global';
import { GlobalVariableService } from "../../../common/variables/global-variable";
import { TranslateService } from "../../../common/variables/translate-service";
import { clearInverterEdit } from '../../../store/senAppProjects.action';

@Component({
  selector: 'sen-app-ac-dc',
  templateUrl: './ac-dc.component.html',
  styleUrls: ['./ac-dc.component.scss']
})

export class AcDcComponent implements OnInit {
  managePath: string;
  itemPath: string;
  prevPath: string;
  panelConnector: boolean = true;
  acDcData: any;
  surgeProtect: string;
  defaultCableLength: number = 10;
  copper: number = 56;
  globalLength: number;
  displayedColumns: string[] = ['SubGen', 'StrCnt', 'length', 'total', 'loss', 'pCount'];
  dataSource = new MatTableDataSource<acDcTable>();
  selectedProject$: Observable<any[]>;
  selectedProjectArray: any;
  selectedProjectUnSubscribe: Subscription;
  convertToLocalNumber: any = Global.convertToLocalNumber;
  @ViewChild(MatTable) acdcCable: MatTable<any>;

  constructor(private routerPath: RouterPathService,
    private router: Router,
    private route: ActivatedRoute,
    public global: GlobalVariableService,
    public globalService: GlobalService,
    private store: Store<any>,
    public translate: TranslateService) {
    this.managePath = this.routerPath.MPProjectPath;
    this.itemPath = `${this.routerPath.manageProjectPath}${this.routerPath.pathSeperator}${this.routerPath.MPItemListString}`;
    this.prevPath = `..${this.routerPath.pathSeperator}${this.routerPath.IPStringingString}`;
    this.selectedProject$ = this.store.select(state => { return state.appData.selectedProject });
    this.selectedProjectUnSubscribe = this.selectedProject$.subscribe(data => {
      this.selectedProjectArray = data;
    });
    this.surgeProtect = SC_Input.sInverter.dcSurgeProtectID;
  }

  ngOnInit(): void {
    this.getAcDcData()
  }

  ngOnDestroy() {
    this.selectedProjectUnSubscribe.unsubscribe();
  }

  getStrCnt(m: any) {
    let c: number = 0;
    m.forEach((s: any) => {
      c += s.stringCount;
    });
    return c;
  }

  setGlobalLength() {
    if (this.globalLength) {
      this.dataSource.data.forEach((element: any) => {
        element.length = this.globalLength;
        element.total = this.formulaTotal(element.StrCnt, this.globalLength);
        element.loss = this.dcCableLoss(element.pCount, this.globalLength, this.acDcData.dcCable.crossSection).lossWatt;
      });
      this.acdcCable.renderRows();
    }
  }

  calculateTotalAndLoss(row: any, ind?: number) {
    row.total = this.formulaTotal(row.StrCnt, row.length);
    row.loss = this.dcCableLoss(row.pCount, row.length, this.acDcData.dcCable.crossSection).lossWatt;
    this.acdcCable.renderRows();
  }

  formulaTotal(strCnt: number, len: number) {
    return strCnt * len * 2
  }

  addCableLength() {
    this.dataSource.data.forEach((acdc: acDcTable, ind: number) => {
      SC_Input.sInverter.subGenerators[ind].dcCableLength = acdc.length;
    });
  }

  getAcDcData() {
    const qParam = {
      cmd: this.global.InverterPlanACDCGet
    };
    this.globalService.getData(qParam).subscribe((data: any) => {
      try {
        if (data && data.ok) {
          this.acDcData = data.ok.data;
          SC_Input.sInverter.subGenerators.forEach((s: any) => {
            let sCount = this.getStrCnt(s.mppt);
            let cableLength = s.dcCableLength ? s.dcCableLength : this.defaultCableLength;
            this.dataSource.data.push(new acDcTable(s.name, sCount, cableLength, this.formulaTotal(sCount, cableLength), this.dcCableLoss(s.panelCount, cableLength, this.acDcData.dcCable.crossSection).lossWatt, s.panelCount))
          });
          this.acdcCable.renderRows();
        }
      } catch { }
    });
  }


  /**
      * Returns loss in Watt and percent
      * @param panel
      * @param panelCount
      * @param cableLength Total cable length of the string (user input * 2)
      * @param crossSection Cable cross section
      */
  dcCableLoss(panelCount: number, cableLength: number, crossSection: number) {
    let result = {
      lossWatt: 0,
      lossPercent: 0,
    };
    let Vpm = SC_Input.sPanel.Vpm * panelCount;
    //voltage loss Uv
    let uvLoss = (cableLength * SC_Input.sPanel.Ipm) / (crossSection * this.copper);
    //power loss Pv in Watt
    let pvLoss = uvLoss * SC_Input.sPanel.Ipm;
    //loss in percent
    let percent = (100 / Vpm) * uvLoss;
    result.lossWatt = pvLoss;
    result.lossPercent = percent;
    return result;
  }

  saveInverterPlan(path: string) {
    this.addCableLength();
    let option: any = {
      id: SC_Input.sInverter.id | 0,
      projectID: SC_Input.sProject.selectedProject.id,
      panelID: SC_Input.sPanel.id,
      panelCount: SC_Input.sInverter.panelCount,
      cosPhi: SC_Input.sInverter.cosPhi ? SC_Input.sInverter.cosPhi : 1,
      dimensionMin: SC_Input.sInverter.dimensionMin ? SC_Input.sInverter.dimensionMin : 80,
      dimensionMax: SC_Input.sInverter.dimensionMax ? SC_Input.sInverter.dimensionMax : 140,
      inverterGroups: SC_Input.sInverter.inverterGroups,
      subGenerators: SC_Input.sInverter.subGenerators,
      panelConnector: this.panelConnector,
      dcSurgeProtectID: this.surgeProtect,
      roofPlans: [],
      invalid: false,
      version: 0,
      OverviewImage: Global.OverviewImage,
      SubGenImage: Global.SubGenImage
    }
    this.selectedProjectArray.roofPlans.forEach((p: ProjectGetRoofPlan) => {
      if (!p.invalid && p.panelID == this.selectedProjectArray.panelID) {
        option.roofPlans.push({ id: p.id });
      }
    });
    const qParam = {
      cmd: this.global.InverterPlanSave
    };
    this.globalService.postData(qParam, option).subscribe(data => {
      try {
        if (data && data.ok) {
          this.store.dispatch(clearInverterEdit());
          if (path == this.itemPath) {
            this.global.targetPath = this.routerPath.MPItemListString;
          }
          this.router.navigate([path], {
            state: { action: this.global.savePlan }
          });
        }
      } catch { }
    });
  }
}

export class acDcTable {
  SubGen: string;
  StrCnt: number;
  length: number;
  total: number;
  loss: number;
  pCount: number;
  constructor(subG: string, sCnt: number, len: number, total: number, loss: number, pCount: number) {
    this.SubGen = subG;
    this.StrCnt = sCnt;
    this.length = len;
    this.total = total;
    this.loss = loss;
    this.pCount = pCount;
  }
}